/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_Jade_Goose_PantInputs */

const en_pale_jade_goose_pant = /** @type {(inputs: Pale_Jade_Goose_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared Content`)
};

const de_pale_jade_goose_pant = /** @type {(inputs: Pale_Jade_Goose_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geteilte Inhalte`)
};

/**
* | output |
* | --- |
* | "Shared Content" |
*
* @param {Pale_Jade_Goose_PantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_jade_goose_pant = /** @type {((inputs?: Pale_Jade_Goose_PantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_Jade_Goose_PantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_jade_goose_pant(inputs)
	return de_pale_jade_goose_pant(inputs)
});